import React from "react";
import { IndexCoordinatorDelegate } from "../IndexCoordinator";
import { LitigationViewController, LitigationViewControllerDelegate } from "../../Screen/Litigation/LitigationViewController";
import { LitigationViewModel } from "../../Screen/Litigation/LitigationViewModel";
import { TableGenericViewController, TableGenericViewControllerDelegate } from "../../Screen/TableGeneric/TableGenericViewController";
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import ProtectedRoute from "../../Components/ProtectedRoute";


export class LitigationCoordinator implements IndexCoordinatorDelegate, TableGenericViewControllerDelegate, LitigationViewControllerDelegate{
    getRoute(): JSX.Element[]{
        return[
            this.routeTable(),
            this.routeForm()
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new TableGenericViewModel("geplitigio")
        return (<ProtectedRoute requiredPermissions={['prop.litigio.*']} path="/:base/litigio" exact={true} component={(props:any) => {
            return (<TableGenericViewController
                permissions={{
                    add: 'prop.litigio.adicionar',
                    edit: 'prop.litigio.editar',
                    delete: 'prop.litigio.excluir',
                }} 
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                title={"Litígio"}
            />)
        }}/>)
    }

    private routeForm(): JSX.Element {
        var viewModel = new LitigationViewModel()
        return (<ProtectedRoute requiredPermissions={['prop.litigio.adicionar', 'prop.litigio.editar']} path="/:base/litigio/cad/:id" exact={true} component={(props:any) => {
            var idPk = props.match.params.id
            return (<LitigationViewController  
                navigation={props}
                viewModel={viewModel}
                delegate={this}
                idPrimary={idPk}
            />)
        }}/>)
    }

    tapDimiss(navigation: any): void{
        navigation.history.goBack();
    }

    add(navigation: any, viewModel: TableGenericViewModel): void{
        if(viewModel.getTable() == "geplitigio"){
            navigation.history.push(`litigio/cad/0`);
            return;
        }
    }

    edit(navigation: any, idSelection: number, viewModel: TableGenericViewModel): void{
        if(viewModel.getTable() == "geplitigio"){
            navigation.history.push(`litigio/cad/${idSelection}`);
            return;
        }
    }

}
